import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { COUPON_PAGE_NAME } from '../../constants/service/app/couponConstants';
import { CouponDetailWrap } from '../../views/coupon-v2/detail/CouponDetailWrap';

const CouponDetail = () => {
  return (
    <PageTemplate pageName={COUPON_PAGE_NAME.COUPON_DETAIL}>
      <CouponDetailWrap />
    </PageTemplate>
  );
};

export default CouponDetail;
